export enum PaymentOptionAWS {
  NO_UPFRONT = "NO_UPFRONT",
  PARTIAL_UPFRONT = "PARTIAL_UPFRONT",
  ALL_UPFRONT = "ALL_UPFRONT",
}
